






































































































































import { editFactory } from '@/main/pages';
import { PAGE_MGR_CLEAR } from '@/main/store/actionTypes';

import { showAlert } from '@/main/utils/notifications';
import { openList } from '@/main/router/routerPath';
import VerifySmsModal from '@/modules/ciselnik/DialogueMarketing/SmsModal/SmsModel.vue';
import VerifyEmailModal from '@/modules/ciselnik/DialogueMarketing/VerifyEmailModal/VerifyEmailModal.vue';

import { Cell, getColumnsRowMapObject } from '@/main/utils/table';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';
import { mapActions } from 'vuex';
import { DEFAULT_SANITIZER_OPTIONS, sanitize } from '@/main/utils/html-sanitizer';

import { VehicleBrand } from '@/main/components/constants';

import { forceFileDownload } from '@/main/utils/fileHelper';
import { PARTNER_COMMUNICATION_MODE } from '@/modules/kartoteka/partner/constants';

import { DEPENDENT_TABLES, BUSINESS_LINE, EmailAttachments, NAME, EMAIL_ATTACHMENT_FILE_TYPE, EMAIL_ATTACHMENT_FILE_MAX_SIZE } from './constants';
import { apiProvider as communicationEventConfigProvider } from './api';

import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		VerifySmsModal,
		VerifyEmailModal,
	},
	data() {
		return {
			saveButton,
			deleteButton,
			visibleSMSModal: false,
			visibleEmailModal: false,
			visiblePreviewEmail: false,
			emailModel: {},
			fileList: [] as any[],
			dependencies: DEPENDENT_TABLES,
			isBusinessLineChanged: false,
		};
	},
	computed: {
		smsCommunicationType(): boolean {
			return this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.MOBILE;
		},
		emailCommunicationType(): boolean {
			return this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.EMAIL;
		},
		disableVerifySMS() {
			return !(this.SMSTemplateId && this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.MOBILE);
		},
		disableVerifyEmail() {
			return !(this.EmailBody && this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.EMAIL);
		},
		previewEmailText() {
			const templateContent = this.dropdownList.EmailTemplate.find((item) => item.Value === this.EmailTemplateId);
			const re = /{#Body#}/gi;
			const emailBody: string = this.EmailBody ? this.EmailBody : '';
			if (templateContent !== undefined) {
				this.EmailBody = templateContent?.TemplateContent.toString();
				return templateContent.TemplateContent.replace(re, emailBody);
			}
			return sanitize(emailBody, { ...DEFAULT_SANITIZER_OPTIONS });
		},
		ritchTextRef() {
			return this.$refs.ritchTextRef;
		},
		previewEmailTitle(): string {
			return this.LocalizePopisostatni('PREVIEW_EMAIL');
		},
	},
	methods: {
		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
		}),
		verifySMSClick() {
			this.visibleSMSModal = true;
		},
		verifyEmailClick() {
			this.emailModel = {
				CommunicationEventId: this.Id,
				FromEmailAddress: this.FromEmailAddress,
			};
			this.visibleEmailModal = true;
		},
		onUpdateVisibleSMSModel() {
			this.visibleSMSModal = false;
		},
		onUpdateVisibleEmailModel() {
			this.visibleEmailModal = false;
		},
		async saveClick() {
			if (await this.validate()) {
				if (this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.MOBILE) {
					this.EmailBody = null;
					this.EmailTo = null;
					this.EmailCc = null;
					this.EmailBcc = null;
					this.EmailSubject = null;
				}
				if (this.TypeOfCommunicationId === PARTNER_COMMUNICATION_MODE.EMAIL) {
					this.SMSTemplateId = null;
					this.SMSTemplate = null;
				}
				this.startLoading();
				const { data: result } = await communicationEventConfigProvider.saveCommunicationEventConfigData(this.edit);
				if (!result) {
					this.endLoading();
					return;
				}
				this.refreshPreviousPage = true;
				this.openCommEventConfigListList();
				this.endLoading();
			}
		},
		async deleteClick() {
			this.startLoading();
			const { data: result } = await communicationEventConfigProvider.deleteCommunicationEventConfigData(this.Id);
			if (!result) {
				this.endLoading();
				return;
			}
			this.refreshPreviousPage = true;
			this.openCommEventConfigListList();
			this.endLoading();
		},
		async openCommEventConfigListList(checkFilters = true) {
			openList(NAME, { checkFilters });
			localStorage.removeItem('FromLogin');
		},
		previewEmailClick() {
			this.visiblePreviewEmail = true;
		},
		handleChange(file: Record<string, any>, fileList: []) {
			this.fileList = fileList;
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		beforeRemove() {
			return true;
		},
		async submitUpload() {
			const formData = new FormData();
			const file = this.fileList[0];
			const filetype = file.raw.type;
			if (filetype !== EMAIL_ATTACHMENT_FILE_TYPE) {
				showAlert({
					message: this.LocalizeChyboveHlasky('DMS_SELECTFILE'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (file.size >= EMAIL_ATTACHMENT_FILE_MAX_SIZE) {
				await this.refreshTable(EmailAttachments);
				showAlert({
					message: this.LocalizeChyboveHlasky('DMS_SELECTFILE'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (file) {
				formData.append('file', file.raw, file.name);
				this.startLoading();
				await communicationEventConfigProvider.saveDocument(formData, this.Id);
				this.fileList = [];
				await this.refreshTable(EmailAttachments);
				this.endLoading();
			}
		},
		async filesDelete(event: Event, cells: Cell[]) {
			const mappedRow: any = getColumnsRowMapObject(this.dependentTables.EmailAttachments.columns, cells) as any;
			await communicationEventConfigProvider.deleteDocuments(mappedRow.ID);
			await this.refreshTable(EmailAttachments);
		},
		async filesDownload(event: Event, cells: Cell[]) {
			this.startLoading();
			const mappedRow: any = getColumnsRowMapObject(this.dependentTables.EmailAttachments.columns, cells) as any;
			const { data: result }: any = await communicationEventConfigProvider.getDocuments(mappedRow.ID);
			if (result.FileData) {
				const url = `data:application/octet-stream;base64,${result.FileData}`;
				forceFileDownload(url, mappedRow.FILENAME);
			}
			this.endLoading();
		},
		resetBrandIdAndDMSFunction(businessLine: string) {
			if (this.isBusinessLineChanged || this.isCreateMode) {
				this.DMSFunctionId = null;
				if (businessLine === BUSINESS_LINE.SALES || businessLine === BUSINESS_LINE.PRESALES) {
					this.BrandId = VehicleBrand.SKODA;
				} else {
					this.BrandId = null;
				}
			}
		},
	},
	watch: {
		SMSTemplateId(smsTemplateId) {
			const template = this.dropdownList.SMSTemplate.find((item) => item.Value === smsTemplateId);
			if (template !== undefined) { this.SMSTemplate = template.SmsTemplate; }
		},
		BusinessLine(businessLine) {
			this.resetBrandIdAndDMSFunction(businessLine);
			if (!this.isBusinessLineChanged) {
				this.dropdownList.AllDMSFunctions = this.dropdownList.DMSFunctionByBusinessLine;
			}
			if (businessLine) {
				this.dropdownList.DMSFunctionByBusinessLine = this.dropdownList.AllDMSFunctions.filter((item) => item.BusinessLine === businessLine);
			}	else {
				this.dropdownList.DMSFunctionByBusinessLine = [];
			}
			this.isBusinessLineChanged = true;
		},
	},
});
